import React, { useState, useEffect } from "react";
import { API_BASE, authHeaders } from "./AgencyContext";

const G = "#0077B5";

export default function AgencyClientDetail({ clientId }) {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clientId) return;
    fetch(`${API_BASE}/app/api/agency/clients/${clientId}/stats`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) setClient(d.client || d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [clientId]);

  if (loading) return <div style={{ padding: 40, textAlign: "center", color: "#888" }}>Loading…</div>;
  if (!client) return <div style={{ padding: 40, textAlign: "center", color: "#888" }}>Client not found.</div>;

  const agencyGlobal = typeof window !== "undefined" ? window.__AGENCY__ : null;
  const brandName = agencyGlobal?.brandName || "BrandHives";

  return (
    <div>
      <a href="#/agency/clients" style={{ fontSize: 13, color: G, textDecoration: "none", marginBottom: 16, display: "inline-block" }}>← Back to clients</a>

      <div style={{ background: "#fff", border: "0.5px solid rgba(0,0,0,0.1)", borderRadius: 12, padding: 24, marginBottom: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 4 }}>{client.client_name}</div>
            <div style={{ fontSize: 13, color: "#888" }}>{client.client_email}</div>
          </div>
          <span style={{ fontSize: 12, background: "#E6F1FB", color: "#0C447C", padding: "4px 12px", borderRadius: 12, fontWeight: 600 }}>
            Managed by {brandName}
          </span>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16, marginTop: 20 }}>
          <div>
            <div style={{ fontSize: 12, color: "#888" }}>Plan</div>
            <div style={{ fontSize: 15, fontWeight: 500, marginTop: 2 }}>{{ honey: "Free", blossom: "Free", standard: "Presence", nectar: "Presence", presence: "Presence", golden: "Authority", authority: "Authority", teams: "Teams", agency: "Agency" }[client.plan] || "Presence"}</div>
          </div>
          <div>
            <div style={{ fontSize: 12, color: "#888" }}>Status</div>
            <div style={{ fontSize: 15, fontWeight: 500, marginTop: 2 }}>{client.status}</div>
          </div>
          <div>
            <div style={{ fontSize: 12, color: "#888" }}>Joined</div>
            <div style={{ fontSize: 15, fontWeight: 500, marginTop: 2 }}>{client.onboarded_at ? new Date(client.onboarded_at).toLocaleDateString() : "Not yet"}</div>
          </div>
        </div>
      </div>

      <div style={{ background: "#fff", border: "0.5px solid rgba(0,0,0,0.1)", borderRadius: 12, padding: 24 }}>
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>Post activity</div>
        <div style={{ fontSize: 13, color: "#888" }}>Post history and analytics will appear here once the client has active posts.</div>
      </div>
    </div>
  );
}
